import { Injectable, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { DEFAULT_CHAT_RECEPTIONIST_AVATAR_SVG_ICON } from '../ai-assistant.constants';


@Injectable({
  providedIn: 'root',
})
export class AiAssistantIconRegistrationService {
  private readonly iconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);
  private iconsRegistered = false;

  async registerIcons(): Promise<void> {
    if (this.iconsRegistered) {
      return;
    }

    const {
      vendastaAiAvatar,
      ChatReceptionistAvatar,
      googleMeetIcon,
      SalesCoachAvatar,
      smsIcon,
      voiceIcon,
      VoiceReceptionistAvatar,
      webchatIcon,
      whatsappIcon,
    } = await import('../../assets/avatars/avatar-svg-string');

    this.iconRegistry.addSvgIconLiteral(
      DEFAULT_CHAT_RECEPTIONIST_AVATAR_SVG_ICON,
      this.sanitizer.bypassSecurityTrustHtml(ChatReceptionistAvatar),
    );
    this.iconRegistry.addSvgIconLiteral(
      'ai-voice-receptionist',
      this.sanitizer.bypassSecurityTrustHtml(VoiceReceptionistAvatar),
    );
    this.iconRegistry.addSvgIconLiteral('ai-sales-coach', this.sanitizer.bypassSecurityTrustHtml(SalesCoachAvatar));
    this.iconRegistry.addSvgIconLiteral('WebchatWidget', this.sanitizer.bypassSecurityTrustHtml(webchatIcon));
    this.iconRegistry.addSvgIconLiteral('SMS', this.sanitizer.bypassSecurityTrustHtml(smsIcon));
    this.iconRegistry.addSvgIconLiteral('Voice', this.sanitizer.bypassSecurityTrustHtml(voiceIcon));
    this.iconRegistry.addSvgIconLiteral('Whatsapp', this.sanitizer.bypassSecurityTrustHtml(whatsappIcon));
    this.iconRegistry.addSvgIconLiteral('vendasta-ai', this.sanitizer.bypassSecurityTrustHtml(vendastaAiAvatar));
    this.iconRegistry.addSvgIconLiteral('GoogleMeet', this.sanitizer.bypassSecurityTrustHtml(googleMeetIcon));

    this.iconsRegistered = true;
  }
}

